// web/src/lib/email.js
// Mirrors isRealEmail() in api/src/lib/email.ts.
//
// The Westwood import invented an address for every client without one, because
// users.email was NOT NULL then. They're syntactically valid and completely
// undeliverable — the subdomain publishes no MX — so the UI must treat one as
// no address at all: no "Invited", and the INFORMATION ONLY badge instead.

const PLACEHOLDER_DOMAIN = '@placeholder.stallside.io';

/** True when a real person could actually receive at this address. */
export function isRealEmail(email) {
  if (!email) return false;
  const e = String(email).trim().toLowerCase();
  return e.includes('@') && !e.endsWith(PLACEHOLDER_DOMAIN);
}

/** What to show where an address goes: the address, or null if there isn't one. */
export function displayEmail(email) {
  return isRealEmail(email) ? email : null;
}
